import React from 'react';

const TennisIntervalDetailsRow = ({ event, competitions }) => {
  const competition = competitions.find((l) => parseInt(l.id) === parseInt(event?.competitionId));
  return (
    <div className="interval__detail-row">
      <div>{competition?.name}</div>
      <div>
        {event.numMatchesScheduled}
        {' '}
        Matches
      </div>
    </div>
  );
};

export default TennisIntervalDetailsRow;
